/** Mensaje de error que devuelve el backend ({ error: "..." }) o uno por defecto. */
export const mensajeError = (err: any, porDefecto: string): string =>
  err?.response?.data?.error || porDefecto;
